var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtfModalUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
    fill: "#00B595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0335 18.6764V18.6743C18.9197 18.6824 18.3326 18.7168 17.0228 18.7168C15.977 18.7168 15.2408 18.6865 14.982 18.6743V18.6774C10.9563 18.5044 7.95154 17.8194 7.95154 16.9999C7.95154 16.1814 10.9563 15.4964 14.982 15.3204V17.9954C15.245 18.0137 15.9988 18.0572 17.0404 18.0572C18.2901 18.0572 18.9165 18.0066 19.0335 17.9965V15.3224C23.0509 15.4974 26.0485 16.1824 26.0485 16.9999C26.0485 17.8194 23.0509 18.5023 19.0335 18.6764ZM19.0335 15.0442V12.6504H24.6393V9H9.37627V12.6504H14.982V15.0432C10.4262 15.2475 7 16.1298 7 17.186C7 18.2423 10.4262 19.1235 14.982 19.3289V27H19.0335V19.3269C23.5821 19.1225 27 18.2413 27 17.186C27 16.1308 23.5821 15.2496 19.0335 15.0442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtfModalUsdtIcon);
export default __webpack_public_path__ + "static/media/ftf_modal_usdt_icon.fee09361c67a599c4416e327ddb5f652.svg";
export { ForwardRef as ReactComponent };